import type { RezaOpravneniDto } from '@gov-nx/api';
import type { QueryKey } from '@tanstack/react-query';
import { deepEqual } from 'fast-equals';

const isQueryKeyExactMatch = (
	queryKey: QueryKey,
	forbiddenQueryKey: QueryKey
): boolean => {
	if (forbiddenQueryKey.length !== queryKey.length) {
		return false;
	}

	return forbiddenQueryKey.every((prefixPart, index) =>
		deepEqual(prefixPart, queryKey[index])
	);
};

export const isAllowedForRezaChange = (
	query: { queryKey: QueryKey },
	forbiddenQueryKeys: QueryKey[]
) =>
	!forbiddenQueryKeys.some((forbiddenQueryKey) =>
		isQueryKeyExactMatch(query.queryKey, forbiddenQueryKey)
	);

export const findRezaByCode = (
	rezaList: RezaOpravneniDto[] | null | undefined,
	code: string | undefined
) => rezaList?.find((reza) => reza.kod === code);
